import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
  useParams,
  Link,
  useNavigate,
  useSearchParams,
  NavLink,
} from "react-router-dom";

import { responsive } from "../../utils/style";
import { Dropdown, Menu } from "antd";

import MILK_THINK from "../../assets/images/ดื่มดี นมวัว.jpg";
import MILK_READ from "../../assets/images/Milk-Hero.gif";
import DRINK_READ from "../../assets/images/รู้ทัน หวานเกิน เมินน้ำตาล.jpg";
import DRINK_THINK from "../../assets/images/การผจญภัยของน้ำตาล.gif";
import VEGGIE_READ from "../../assets/images/สุขชัวร์ เพิ่มผัก.jpg";
import VEGGIE_THINK from "../../assets/images/เมนูผัก ดี๊ดี.gif";
import MOVE_THINK from "../../assets/images/มูฟ อีซีย์.gif";
import MOVE_READ from "../../assets/images/สูงฟิต คิดเก่ง.jpg";

import ICON from "../../assets/icons/help-circle.svg";
import HelperMenu from "../../components/monkHelper/HelperMenu";

const DATA = {
  milk: {
    topic: "ดื่มดี นมวัว",
    suggest: "วันละ 1-2 กล่อง",
    think: {
      image: MILK_READ,
      description: "มาเป็นมิลค์ฮีโรกันเถอะ",
    },
    read: {
      image: MILK_THINK,
      description: "ดื่มดี นมวัว",
    },
  },
  veggie: {
    topic: "สุขชัวร์ เพิ่มผัก",
    suggest: "วันละ 6-12 ช้อนโต๊ะ",
    think: {
      image: VEGGIE_THINK,
      description: "เมนูผักดี๊ ดี",
    },
    read: {
      image: VEGGIE_READ,
      description: "สุขชัวร์ เพิ่มผัก",
    },
  },
  move: {
    topic: "รักออกกำลัง",
    suggest: "วันละอย่างน้อย 60 นาที",
    think: {
      image: MOVE_THINK,
      description: "มูฟ อีซีย์",
    },
    read: {
      image: MOVE_READ,
      description: "สูง ฟิต คิดเก่ง",
    },
  },
  drink: {
    topic: "หยุดยั้ง น้ำหวาน",
    suggest: "ไม่ดื่มน้ำหวาน",
    think: {
      image: DRINK_THINK,
      description: "การผจญภัยของน้ำตาล",
    },
    read: {
      image: DRINK_READ,
      description: "รู้ทัน หวานเกิน เมินน้ำตาล",
    },
  },
};

const Article = () => {
  const { type } = useParams();
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const key = searchParams.get("key");
  const [currTab, setCurrTab] = useState(key || "think");
  const info = DATA[type] || {};

  useEffect(() => {
    if (Object.keys(info).length === 0) {
      navigate("/");
    }
  });

  return (
    <Container>
      <Background>
        <TopicSection>
          <TopicLeft>{info?.topic}</TopicLeft>
          <TopicRight>เป้าหมาย{info?.suggest}</TopicRight>
        </TopicSection>
        <Body>
          <TabContainer>
            <Tab
              active={currTab === "think"}
              onClick={() => setCurrTab("think")}
            >
              ชวนคิด
            </Tab>
            <Tab active={currTab === "read"} onClick={() => setCurrTab("read")}>
              ชวนอ่าน
            </Tab>
          </TabContainer>
          <Detail>{info[currTab]?.description}</Detail>
          <Img src={info[currTab]?.image} />
          <ActionWrapper>
            <Dropdown overlay={<HelperMenu />} placement="topLeft" arrow>
              <HelperButton>
                <img src={ICON} style={{ marginRight: "8px" }} />
                ทำไม่ถึงเป้าหมายขอตัวช่วย
              </HelperButton>
            </Dropdown>
            {/* <ButtonStyled to="/">
              <img src={ICON} />
              ทำไม่ถึงเป้าหมายขอตัวช่วย
            </ButtonStyled> */}
          </ActionWrapper>
        </Body>
      </Background>
    </Container>
  );
};

export default Article;

const HelperButton = styled.div`
  margin-top: 16px;
  border-radius: 100px;
  background: #b5f6df;
  /* Primary/Green 400 */
  text-align: center;
  border: 1px solid #16af7b;
  font-weight: 600;
  font-size: 19px;
  color: #16af7b;
  cursor: pointer;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 32px;
  padding-right: 32px;

  ${responsive.mobile(css`
    width: 100%;
  `)}
`;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;
  width: 100%;
`;
const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  background-color: white;
  padding: 40px 116px;
  margin: auto;

  ${responsive.tablet(css`
    padding: 40px 32px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px 16px;
  `)}
`;
const Body = styled.div`
  margin: auto;
  width: 770px;

  ${responsive.tablet(css`
    width: 100%;
  `)}
`;
const TopicSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
`;
const TopicLeft = styled.h4`
  font-style: normal;
  letter-spacing: -0.02em;
  color: #058459;
  font-size: 28px;
  line-height: 34px;
  font-weight: 700;

  ${responsive.mobile(css`
    font-size: 23px;
    line-height: 28px;
    font-weight: 600;
  `)}
`;
const TopicRight = styled.h4`
  font-style: normal;
  color: #fc6b4b;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;

  ${responsive.tablet(css`
    font-size: 23px;
    line-height: 28px;
    font-weight: 700;
  `)}
  ${responsive.mobile(css`
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
  `)}
`;
const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 40px;

  ${responsive.mobile(css`
    margin-top: 24px;
  `)}
`;
const Tab = styled.div`
  height: 38px;
  flex: 0.5;
  font-weight: ${(props) => (props.active ? "700" : "400")};
  font-size: 23px;
  line-height: 28px;
  text-align: center;
  color: ${(props) => (props.active ? "#4b5768" : "#64748B")};
  border-bottom: ${(props) =>
    props.active ? "3px solid #fc6b4b" : "2px solid #64748B"};

  &:hover {
    cursor: pointer;
  }

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;
  `)}
`;
const Img = styled.img`
  width: 100%;
`;
const Detail = styled.h4`
  font-weight: 700;
  font-size: 23px;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #4b5768;
  margin: 36px 0 24px 0;
`;
const ActionWrapper = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 32px;

  ${responsive.mobile(css`
    margin-top: 24px;
  `)}
`;
const ButtonStyled = styled(Link)`
  flex: 1;
  background: #b5f6df;
  border: 1px solid #16af7b;
  border-radius: 100px;
  padding: 14px 32px;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;
  color: #16af7b;

  img {
    margin-right: 9.33px;
  }
  max-width: 343px;
`;
